import React, { Component } from 'react';
import mockup from "../assets/mockups/mobile-mockup.png";

class HeroArt extends Component {
  render() {
    return (
      <div className="hero-mockup">
        <img src={mockup} alt="Mobil uygulama mockup" />
      </div>
    );
  }
}

export default HeroArt;
